import React from "react";

const Answer = ({
  ansvalue,
  onSelectedAnswer,
  index,
  currentAnswer,
  correctAnswer,
}) => {
  const indexMapping = ["A", "B", "C", "D"];
  const isCorrect = currentAnswer && ansvalue === correctAnswer;
  const isWrong = currentAnswer === ansvalue && currentAnswer !== correctAnswer;
  console.log("currentAnswer", currentAnswer);
  console.log("correctAnswer", correctAnswer);
  console.log("ansvalue", ansvalue);
  const correctAnswerClass = isCorrect ? "correct-answer" : "";
  const wrongAnswerClass = isWrong ? "wrong-answer" : "";
  const disabledAnswerClass = currentAnswer ? "disabled-answer" : "";
  return (
    <div
      className={`answer ${correctAnswerClass} ${wrongAnswerClass} ${disabledAnswerClass}`}
      onClick={() => onSelectedAnswer(ansvalue)}
    >
      <div className="answer-letter">{indexMapping[index]}</div>
      <div className="answer-text">{ansvalue}</div>
    </div>
  );
};

export default Answer;
